// removed by extract-text-webpack-plugin
module.exports = {"BannerImage":"src-components-ForParents-BannerImage----BannerImage-module---BannerImage---2PSfy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ForParents/BannerImage/BannerImage.module.scss
// module id = 167
// module chunks = 29102153025240 117294837363437 172031202348862